import React, {
  ChangeEvent,
  forwardRef,
  useState,
} from 'react';
import CheckboxMUI, { CheckboxProps as MUICheckboxProps } from '@mui/material/Checkbox';
import ErrorMessage from './ErrorMessage';

interface CheckboxProps extends Omit<MUICheckboxProps, 'onChange'> {
  label?: string;
  isChecked?: boolean;
  labelClassName?: string;
  onCheckChange?: (isChecked: boolean) => void;
  errMsg?: string;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const Checkbox = forwardRef<
HTMLButtonElement,
CheckboxProps
>(({
  id, label, isChecked, labelClassName, errMsg, onCheckChange, disabled, size = 'medium', ...rest
}, ref) => {
  const [checked, setChecked] = useState(isChecked);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    if (onCheckChange) {
      onCheckChange(newChecked);
    }
  };

  return (
    <div className='mb-2'>
      <div className='flex items-center'>
        {label ? (
          <div className='flex flex-row gap-2 items-center'>
            <CheckboxMUI
              ref={ref}
              checked={checked}
              onChange={handleCheckboxChange}
              disabled={disabled}
              id={id}
              size={size}
              sx={{
                backgroundColor: 'rgb(var(--color-surface-base))',
                color: 'rgb(var(--color-primary-500))',
                '&.Mui-checked': {
                  color: 'rgb(var(--color-primary-500))',
                },
                '&.Mui-disabled.Mui-checked': {
                  color: 'rgb(var(--color-neutral-400))',
                },
                '&.Mui-disabled': {
                  opacity: 0.7,
                },
                padding: '0px',
                paddingRight: '4px',
              }}
            />
            <p className={`${labelClassName}`}>{label}</p>
          </div>
        ) : (
          <CheckboxMUI
            ref={ref}
            checked={checked}
            onChange={handleCheckboxChange}
            disabled={disabled}
            id={id}
            size={size}
            sx={{
              backgroundColor: 'rgb(var(--color-surface-base))',
              color: 'rgb(var(--color-primary-500))',
              '&.Mui-checked': {
                color: 'rgb(var(--color-primary-500))',
              },
              '&.Mui-disabled.Mui-checked': {
                color: 'rgb(var(--color-neutral-400))',
              },
              '&.Mui-disabled': {
                opacity: 0.7,
              },
              padding: '0px',
              paddingRight: '4px',
            }}
            {...rest}
          />
        )}
      </div>
      <ErrorMessage message={errMsg} />
    </div>
  );
});

export default Checkbox;
